import appStore from './AppStore';
import routeStore from './RouterStore';
import flexMessageGateway from './FlexMessageGateway';

const stores = {
  app: appStore,
  router: routeStore,
  fmg: flexMessageGateway
};

export default stores;
